/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Underscore_LabelInputs */

const en_style_guide_manager_underscore_label = /** @type {(inputs: Style_Guide_Manager_Underscore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Underscore _`)
};

const fr_style_guide_manager_underscore_label = /** @type {(inputs: Style_Guide_Manager_Underscore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiret bas _`)
};

const de_style_guide_manager_underscore_label = /** @type {(inputs: Style_Guide_Manager_Underscore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstrich _`)
};

const it_style_guide_manager_underscore_label = /** @type {(inputs: Style_Guide_Manager_Underscore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottolineatura _`)
};

const ru_style_guide_manager_underscore_label = /** @type {(inputs: Style_Guide_Manager_Underscore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подчеркивание _`)
};

const es_style_guide_manager_underscore_label = /** @type {(inputs: Style_Guide_Manager_Underscore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guión bajo _`)
};

const zh_cn2_style_guide_manager_underscore_label = /** @type {(inputs: Style_Guide_Manager_Underscore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下划线`)
};

const ja_style_guide_manager_underscore_label = /** @type {(inputs: Style_Guide_Manager_Underscore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アンダースコア _`)
};

const hi_style_guide_manager_underscore_label = /** @type {(inputs: Style_Guide_Manager_Underscore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंडरस्कोर _`)
};

const pt_pt2_style_guide_manager_underscore_label = /** @type {(inputs: Style_Guide_Manager_Underscore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sublinhado _`)
};

/**
* | output |
* | --- |
* | "Underscore _" |
*
* @param {Style_Guide_Manager_Underscore_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_underscore_label = /** @type {((inputs?: Style_Guide_Manager_Underscore_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Underscore_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_underscore_label(inputs)
	if (locale === "de") return de_style_guide_manager_underscore_label(inputs)
	if (locale === "it") return it_style_guide_manager_underscore_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_underscore_label(inputs)
	if (locale === "es") return es_style_guide_manager_underscore_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_underscore_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_underscore_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_underscore_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_underscore_label(inputs)
	return en_style_guide_manager_underscore_label(inputs)
});